import Layout from '@seaweb/coral/components/Layout';
import { Title } from '@seaweb/coral/components/Typography';
import { useRouter } from 'next/router';
import { array, bool, number } from 'prop-types';
import { useViewContext } from 'providers/ViewContextProvider';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import CategoryTabList from './CategoryTabList';
import CategoryTabListMobile from './CategoryTabListMobile';
import CategoryBackground from './CategoryBackground.svg';

const Header = styled(Layout)`
  background-color: #2091f1;
  height: ${(props) => (props.isMobileView ? '122px' : '316px')};
  display: flex;
  justify-content: center;
  position: relative;
  overflow: hidden;

  > svg {
    position: absolute;
    width: 2560px;
    height: ${(props) => (props.isMobileView ? '122px' : '316px')};
    z-index: 0;
    margin: auto;
    left: 50%;
    transform: translate(-50%, 0);
  }

  ${(props) =>
    props.isMobileView
      ? 'padding-left:16px; padding-right:16px;width:calc(100% - 32px);'
      : ''}
`;

const TextSection = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1160px;
  margin: auto;
  width: 100%;
  z-index: 1;

  ${(props) => (props.isMobileView ? 'margin-top: 20px;' : '')}
`;

const HeaderTitle = styled(Title)`
  height: ${(props) => (props.isMobileView ? 'unset' : '46px')};
  font-size: ${(props) => (props.isMobileView ? '24px' : '32px')};
  font-weight: 700;
  color: white;
  margin: 0 0 0 16px;
  text-align: left;

  > * {
    margin-right: 8px;
  }

  @media screen and (max-width: 600px) {
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const Description = styled.div`
  ${(props) =>
    props.isMobileView
      ? 'padding-top:4px;font-size:12px;line-height: 18px;'
      : 'padding: 24px 0;'}

  margin: 0 0 0 16px;
  color: #ffffff;
  text-align: left;

  @media screen and (max-width: 600px) {
    margin: 0;
  }
`;

const CategoryInfo = ({
  categories,
  currentCategoryId,
  isScrollDown,
  beyondThreshold,
}) => {
  const { isMobileView } = useViewContext();
  const currentCategory = useMemo(() => {
    return categories.find((cat) => cat.id === currentCategoryId);
  }, [categories, currentCategoryId]);
  const { pathname } = useRouter();
  const CategoryTabListComponent = isMobileView
    ? CategoryTabListMobile
    : CategoryTabList;
  const notHiddenWhenScrollDown = pathname === '/categories/[categoryId]';

  return (
    <>
      <Header isMobileView={isMobileView}>
        <CategoryBackground />

        <TextSection isMobileView={isMobileView}>
          <HeaderTitle isMobileView={isMobileView}>
            {currentCategory.name}
          </HeaderTitle>
          <Description isMobileView={isMobileView}>
            {currentCategory.description}
          </Description>
        </TextSection>
      </Header>

      <CategoryTabListComponent
        currentCategoryId={currentCategoryId}
        currentCategory={currentCategory}
        categories={categories}
        isScrollDown={isScrollDown}
        beyondThreshold={beyondThreshold}
        notHiddenWhenScrollDown={notHiddenWhenScrollDown}
      />
    </>
  );
};

CategoryInfo.propTypes = {
  categories: array,
  currentCategoryId: number,
  isScrollDown: bool,
  beyondThreshold: bool,
};

export default CategoryInfo;
